export default __webpack_public_path__ + "static/media/hd-pink-III-new.8da19a35.mp4";